import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom";
import "./assets/scss/style.scss";
import Spinner from "./views/spinner/Spinner";
import * as serviceWorker from './serviceWorker';
import Axios from "axios";
import IdleMonitor from "./IdleMoniter";

// setup fake backend
// import { ConfigureFakeBackend } from "./jwt/_helpers";
// ConfigureFakeBackend();

// Axios.interceptors.request.use(function (config) {
//   config.headers = {'Content-Type': 'application/json',"Access-Control-Allow-Origin": window?.location?.origin ?? '*' };
//   return config;
// });

//Axios.defaults.headers.common['Access-Control-Allow-Origin'] = window?.location?.hostname ?? '*';

const App = lazy(() => import("./App"));

ReactDOM.render(
  <Suspense fallback={<Spinner />}>
    <IdleMonitor />
    <App />
  </Suspense>,
  document.getElementById("root")
); serviceWorker.unregister();